import React from 'react';

const IsLiteContext = React.createContext({
    isLiteLayout: false,
    isMobile: false
});
const IsLiteProvider = IsLiteContext.Provider;

export { IsLiteContext, IsLiteProvider };
